// src/App.jsx

import React from 'react';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ToastProvider } from './components/common/Toast';
import { storeEntry } from './services/appEntry';
import {startupText,storefrontStartupText,publicStartupText} from './i18n/startup';
const MerchantApp = React.lazy(() => import('./MerchantApp').then(module => ({default:module.MerchantApp})));
const ReceptionGuide = React.lazy(()=>import('./pages/Help/ReceptionGuide').then(module=>({default:module.ReceptionGuide})));
const ProductIntro = React.lazy(()=>import('./pages/Help/ProductIntro').then(module=>({default:module.ProductIntro})));
const CommerceStore = React.lazy(() => import('./pages/Commerce/CommerceStore').then((module) => ({ default:module.CommerceStore })));
const commerceFallback = () => <div className="min-h-screen bg-slate-950 p-8 text-center text-sm text-slate-400">{storefrontStartupText('storeLoading')}</div>;

export function App() {
  if(window.location.pathname==='/product-intro')return <ErrorBoundary text={publicStartupText}><React.Suspense fallback={<div role="status" className="min-h-screen bg-gray-950 p-8 text-gray-100">{publicStartupText('loading')}</div>}><ProductIntro/></React.Suspense></ErrorBoundary>;
  if(window.location.pathname==='/reception-guide')return <ErrorBoundary text={publicStartupText}><React.Suspense fallback={<div role="status" className="min-h-screen bg-gray-950 p-8 text-gray-100">{publicStartupText('loading')}</div>}><ReceptionGuide/></React.Suspense></ErrorBoundary>;
  const store = storeEntry(window.location, window.Telegram?.WebApp?.initDataUnsafe?.start_param);
  if (store) return <ErrorBoundary text={storefrontStartupText}><React.Suspense fallback={commerceFallback()}><ToastProvider><CommerceStore botId={store.botId} initialProductId={store.productId} initialNegotiationQuoteId={store.quoteId} /></ToastProvider></React.Suspense></ErrorBoundary>;
  return <ErrorBoundary><React.Suspense fallback={<div className="min-h-screen p-8 text-center text-sm text-gray-400">{startupText('loading')}</div>}><MerchantApp /></React.Suspense></ErrorBoundary>;
}

function TelegramLogin({ onLogin }) {
  const containerRef = React.useRef(null);
  React.useEffect(() => {
    const callbackName = `telegramLogin_${Date.now()}`;
    window[callbackName] = onLogin;
    const script = document.createElement('script');
    script.src = 'https://telegram.org/js/telegram-widget.js?22';
    script.async = true;
    script.setAttribute('data-telegram-login', 'TBSaaS_bot');
    script.setAttribute('data-size', 'large');
    script.setAttribute('data-radius', '12');
    script.setAttribute('data-request-access', 'write');
    script.setAttribute('data-onauth', `${callbackName}(user)`);
    containerRef.current?.appendChild(script);
    return () => { delete window[callbackName]; if (containerRef.current) containerRef.current.innerHTML = ''; };
  }, [onLogin]);
  return <div ref={containerRef} className="flex justify-center min-h-[42px]" />;
}
